module.exports = __webpack_public_path__ + "assets/保存.af6d2cbb.svg";